// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"178":"game-data","250":"graph-data","284":"ariadne-data","796":"definitions-data"}[chunkId] || chunkId) + "." + {"178":"d07cdc4c","250":"6ba87d44","256":"6a74003e","283":"d3398eb4","284":"215ba324","324":"8828e0ca","359":"9154e60e","657":"4f3962b7","796":"d212ce16","986":"b7addd6c"}[chunkId] + ".chunk.js";
};